const validateAnswer = function (errors, vm, showTip) {
  const { value, tipsMsg, answerConfig: { requireInd } } = this
  let { mediaQuType, screenCode, answerConfig: { minAnswerNum, maxAnswerNum, validateRuleType, validateRuleValue } } = this
  minAnswerNum *= 1
  maxAnswerNum *= 1

  if (mediaQuType) {
    screenCode = mediaQuType
  }

  const minMaxValid = () => {
    if (minAnswerNum > 0 && value.length < minAnswerNum) {
      let minRequiredPhrase = vm.cvtLang('minRequired', vm.surveyInfoLang.minRequired) || ''
      errors.push(minRequiredPhrase.replace('${n}', minAnswerNum))
    }

    if (maxAnswerNum > 0 && value.length > maxAnswerNum) {
      let maxRequiredPhrase = vm.cvtLang('maxRequired', vm.surveyInfoLang.maxRequired) || ''
      errors.push(maxRequiredPhrase.replace('${n}', maxAnswerNum))
    }
  }

  // 开放题
  if (requireInd === '1' && !screenCode) {
    if (!value.trim()) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
    } else {
      minMaxValid()
    }

    return !errors.length
  }

  // 个人信息题
  if (screenCode) {
    if (requireInd === '1' && !value.trim()) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
    if (screenCode === 'xingming' && value.trim()) {
      // 姓名
      minMaxValid()
    } else if (screenCode === 'phone1' && value.trim()) {
      // 手机
      if (!/^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value.trim())) {
        errors.push(vm.cvtLang('tipsPhoneError', vm.surveyInfoLang.tipsPhoneError))
      }
    } else if (screenCode === 'email' && value.trim()) {
      // 邮箱
      if (!/^[\w-_]+(\.[\w-_]+)*@[\w-_]+((\.[\w-_]+)+)$/.test(value.trim())) {
        errors.push(vm.cvtLang('tipsEmailError', vm.surveyInfoLang.tipsEmailError))
      }
    } else if (screenCode === 'idCard' && value.trim()) {
      // 身份证
      if (
        !(
            // 大陆
          /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value.trim()) ||
          // 香港
          /^[A-Z]{1,2}[0-9]{6,10}[0-9A-Z]$/.test(value.trim()) ||
          // 澳门
          /^[1|5|7][0-9]{6}[0-9A-Z]$/.test(value.trim()) ||
          // 台湾
          /^[a-zA-Z][0-9]{9}$/.test(value.trim())
        )
      ) {
        errors.push(vm.cvtLang('tipsIdCardError', vm.surveyInfoLang.tipsIdCardError))
      }
    } else if (screenCode === 'infocollection' && value.trim()) {
      // 信息采集题
      let validReg
      let regMsg
      switch(validateRuleType) {
        case '0':
          // 不限
          validReg = ``
          minMaxValid()
          break;
        case '1':
          // 中文
          validReg = `^[\u4e00-\u9fa5]{0,}$`
          regMsg = vm.cvtLang('tipsChineseError', vm.surveyInfoLang.tipsChineseError)
          break;
        case '2':
          // 字母
          validReg = `^[A-Za-z]+$`
          regMsg = vm.cvtLang('tipsLetterError', vm.surveyInfoLang.tipsLetterError)
          break;
        case '3':
          // 网址
          validReg = `^(https|http|ftp|rtsp|mms):\\/\\/[\\s\\S]+`
          regMsg = vm.cvtLang('tipsUrlError', vm.surveyInfoLang.tipsUrlError)
          break;
        case '4':
          // 自定义
          validReg = validateRuleValue
          regMsg = vm.cvtLang('tipsFormatLimit', vm.surveyInfoLang.tipsFormatLimit)
          break;
      }
      const reg = new RegExp(validReg)
      if (!reg.test(value.trim())) {
        errors.push(regMsg)
      }
      if (['1', '2', '4'].includes(validateRuleType)) {
        minMaxValid()
      }
    }
  }

  // 自定义提示语
  if (tipsMsg) {
    errors.push(tipsMsg)
  }

  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/TitleBox/answerValidate.js